import React, { useCallback, useContext } from 'react'
import { Container, Form, Button } from 'react-bootstrap'
// Component Imports
import LocationDropDown from './LocationDropDown'
import SubCategoryDropDown from './SubCategoryDropDown'
import NameSearch from './NameSearch'
// Context Imports
import { ListContext } from '../../contexts/ListContext'
// Asset Imports 
import '../../assets/css/stylesheets/pages/Home/AdvancedSearch.css'

function AdvancedSearch() {
    const {
        searchText,
        setSearchText,
        category,
        subCategory,
        setSubCategory,
        location,
        setLocation,
        isQueenOfQuality,
        setIsQueenOfQuality,
        isPerformanceProgram,
        setIsPerformanceProgram
    } = useContext(ListContext)

    const handleSearchTextChanged = useCallback((e) => {
        setSearchText(e.target.value);
    })

    const handleSubCategoryChanged = useCallback((e) => {
        setSubCategory(e.target.value);
    })

    const handleLocationChanged = useCallback((e) => {
        setLocation(e.target.value);
    })

    // Reset function to reload the page
    const handleReset = useCallback(() => {
        window.location.reload();
    }, []);

    return (
        <Container className="advancedsearch">
            <h4 className='advancedsearch-header'>Advanced Search</h4>
            <div className='advancedsearch-seperator'></div>
            <div className='advancedsearch-list'>
                <NameSearch
                    textValue={searchText}
                    onTextChanged={handleSearchTextChanged} />
                <LocationDropDown
                    selectedValue={location}
                    onLocationChanged={handleLocationChanged} />
                <SubCategoryDropDown
                    categoryID={category}
                    selectedValue={subCategory}
                    onSubCategoryChanged={handleSubCategoryChanged} />
            </div>
            <h4 className='advancedsearch-header'>Additional Options</h4>
            <div className='advancedsearch-seperator'></div>
            <div className="advancedsearch-list">
                <Form.Check
                    type='checkbox'
                    id='chk_QueenOfQuality'
                    label='Queen of Quality'
                    checked={isQueenOfQuality}
                    onChange={(e) => { setIsQueenOfQuality(e.target.checked) }}
                />
                 <div className="advancedsearch-dropdown">
                    <Form.Select
                    id="select_PerformanceProgram"
                    value={isPerformanceProgram}
                    onChange={(e) => setIsPerformanceProgram(e.target.value)}
                >
                    <option value="">Select Performance Program</option>
                    <option value="NONE">No Program</option>
                    <option value="REAP">REAP</option>
                    <option value="TPE">TPE</option>
                    <option value="FLAIR">FLAIR</option>
                    <option value="PERF">Performance</option>
                </Form.Select>
                </div>
                <div className="advancedsearch-reset">
                <Button 
                    variant="secondary" 
                    onClick={handleReset}
                    className="mt-3"
                >
                    Reset Search
                </Button>
            </div>
            </div>            
            
        </Container>
    )
}

export default AdvancedSearch